import React, { useState, useEffect } from "react";
import { ERRORS_SHOW_TIME } from "../../configs";

const TableCellErrorMessage = ({ feature, type, errors }): JSX.Element => {
  const searchingItem = `${feature.toUpperCase()}-${type}`;

  const [show, setShow] = useState(true);

  useEffect(() => {
    let timeId;

    if (errors && errors[searchingItem]) {
      timeId = setTimeout(() => {
        setShow(false);
      }, ERRORS_SHOW_TIME);
    } else {
      setShow(true);
    }

    return () => {
      clearTimeout(timeId);
    };
  }, [errors]);

  if (!show && errors && errors[searchingItem]) {
    return null;
  }

  return (
    <React.Fragment>
      {errors && errors[searchingItem] && (
        <p data-tooltip={errors[searchingItem]}></p>
      )}
    </React.Fragment>
  );
};

export default TableCellErrorMessage;
